import React from 'react';
import SelectComponent from '../SelectComponent';

interface ValuesOptions {
  id?: string | number;
  name?: string;
  value?: string | number;
}

interface Props {
  id: string;
  value: string | number;
  values: ValuesOptions[];
  style?: React.CSSProperties;
  onChange?: (event: ValuesOptions) => void;
  label: string;
  labelId?: string;
  input?: {
    value: string | number;
    onChange: (
      event: ValuesOptions
    ) => void;
  };
  onFieldChange?: (
    event: ValuesOptions
  ) => void;
}

const TimePicker: React.FC<Props> = ({
  id,
  value,
  values,
  style,
  onChange = () => {},
  label,
  labelId,
  ...props
}) => {
  return (
    <SelectComponent
      id={id}
      label={label}
      labelId={labelId}
      value={value}
      values={values}
      style={style || { width: '100%', color: 'black' }}
      onChange={(event) => {
        onChange(event);
        if (props.onFieldChange) props.onFieldChange(event);
        if (props.input?.onChange) props.input.onChange(event);
      }}
      {...props}
    />
  );
};

export default TimePicker;
